// extracted by mini-css-extract-plugin
module.exports = {"artistName":"App_artistName__1A5--","primaryLink":"App_primaryLink__1rlLe","menuLine":"App_menuLine__Ifyir","footer":"App_footer__2AwD9","linkFooter":"App_linkFooter__ocIJO"};